module.exports = __webpack_public_path__ + "static/img/block3-bg.a677f2b4.png";